import { getSession } from '../auth';

export function renderPayrollHistory(): string {
  const session = getSession();
  const role = session?.role || '';
  const isStaff = role === 'educator' || role === 'admin' || role === 'owner';
  return (
    '<div class="screen-head"><div><div class="t-eyebrow">Payroll</div><h1 class="t-h1">' + (isStaff ? 'Pay history' : 'My payslips') + '</h1>' +
    '<p class="t-meta">Approved periods appear here with downloadable payslips.</p></div></div>' +
    '<div class="card card-pad-lg empty"><div class="empty-illus">₹</div><h2>No approved periods yet</h2>' +
    '<p style="font-size: var(--t-sm);">Runs are approved by the workspace owner in Payroll → New period. After approval, each payslip is generated and stored here.</p></div>'
  );
}

export function bindPayrollHistory(): void {}
